import environment from "@/modules/environment";

const linkEnum = {
  bibino_en: "https://www.iubenda.com/privacy-policy/91528467/full-legal",
  bibino_de: "https://www.iubenda.com/privacy-policy/84138006/full-legal",
  bibino_fr: "https://www.iubenda.com/privacy-policy/91656052/full-legal",
  bibino_nl: "https://www.iubenda.com/privacy-policy/89139708/full-legal",
  bibino_cs: "https://www.iubenda.com/privacy-policy/46386050/full-legal",
  barkio_en: "https://www.iubenda.com/privacy-policy/41537995/full-legal",
  barkio_cs: "https://www.iubenda.com/privacy-policy/87004222/full-legal",
  barkio_de: "https://www.iubenda.com/privacy-policy/57196090/full-legal",
  camerito_en: "https://www.iubenda.com/privacy-policy/34584969/full-legal",
  camerito_cs: "https://www.iubenda.com/privacy-policy/77599280/full-legal"
};

const { appName } = environment;
export default function getPrivacyPolicyLinkByLocale(locale: LanguageCode) {
  return linkEnum[`${appName}_${locale}` as keyof typeof linkEnum] || linkEnum[`${appName}_en`];
}
